import jQuery from 'jquery'

jQuery.migrateMute = true
